import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$lang/orgs/$org/internal/whs/$location/home",
      params,
    });
  },
  component: () => <div></div>,
});
